import { HttpHeaders } from '@angular/common/http';

/** A header to skip the server error interceptor */
export const InterceptorSkip = 'X-Skip-Interceptor';
/** A header to skip the server error interceptor */
export const InterceptorSkipHeader = new HttpHeaders({
  'X-Skip-Interceptor': '',
});
